
export default function useLog(function_id){

	return function log (...args) {

        console.log(function_id, ...args)
        
    }
}
